'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    menu: {
      boxShadow: theme.menu.boxShadow,
      color: 'inherit',
      backgroundColor: theme.menu.bgColor,
      minWidth: 160,
      maxWidth: 320,
      overflowX: 'hidden',
      overflowY: 'auto',
      maxHeight: '50vh',
      '&.openUp': {// TODO доработать открытие вверх
      },
      '&.disabled': {
        opacity: theme.disabledOpacity,
        cursor: 'default'
      },
      '&.hidden': {
        maxHeight: '0vh',
        boxShadow: 'none',
        padding: 0,
        opacity: 0
      }
    },
    small: {
      paddingTop: 4,
      paddingBottom: 4,
      borderRadius: 3
    },
    medium: {
      paddingTop: 8,
      paddingBottom: 8,
      borderRadius: 4
    },
    large: {
      paddingTop: 8,
      paddingBottom: 8,
      borderRadius: 4
    }
  };
};